// 參考: https://github.com/benjamhawk/MUI-RHF-components/blob/main/src/CheckboxGroup.tsx

import RhfCheckBox from './RhfCheckBox'
import { CheckboxProps, FormControlLabelProps, FormGroup, FormGroupProps } from '@mui/material'
import React from 'react'
import { RhfOption } from './types/RhfOption'
import { RhfProps } from './types/RhfProps'
import { RhfStyleProps } from './types/RhfStyleProps';

export const CHK_PREFIX = "chk_";

type Props = RhfProps & RhfStyleProps & {
    row?: boolean;
    options?: RhfOption[] | string[] | object[];
    children?: React.ReactNode;

    displayMember?: string;
    valueMember?: string;

    optionPrefix?: string;

    formGroupProps?: FormGroupProps;
    markProps?: CheckboxProps;// CheckboxProps - 統一的 Checkbox 屬性樣式
    formControlLabelProps?: FormControlLabelProps
}

const RhfCheckGroup = ({ rhf, name, defaultValue, rules, // RhfProps
    sx, className, style,// RhfStyleProps

    row, options, children,
    displayMember, valueMember,

    optionPrefix,

    formGroupProps,
    markProps,
    formControlLabelProps,
    ...restProps
}: Props) => {

    // if (row == null) {
    //     row = true;// 預設橫向排列
    // }

    if (displayMember == null) {
        displayMember = "label";
    }

    if (valueMember == null) {
        valueMember = "value";
    }

    const prefix: string | undefined = (optionPrefix == null ? CHK_PREFIX : optionPrefix);



    return (
        <FormGroup {...formGroupProps} row={row}
            sx={sx} className={className} style={style}
        >
            {options == null ? <></> : options.map((option: any) => {

                if (typeof (option) === "string") {
                    option = { value: option, label: option }
                }

                const val = String(option[valueMember as string]);
                const lbl = option[displayMember as string];

                if ((prefix != null && prefix !== "") || is_pos_int_or_zero(val) === false) {
                    // pass 有文字當前綴，就不是整數
                } else {
                    throw new Error(`RhfCheckGroup::選項的 name=${name}.${val} 不可為數字 !!!`);
                }

                const key = `${name}.${prefix}${val}`;
                const chk_name = `${name}.${prefix}${val}`;
                
                return (
                    <RhfCheckBox rhf={rhf} key={key} name={chk_name} label={lbl}
                        markProps={markProps}
                        formControlLabelProps={formControlLabelProps}
                    />
                )
            })}
            {children}
        </FormGroup>
    );

}

export function is_pos_int_or_zero(str: string): boolean {
    if (str == null) {
        return false;
    } else {
        return /^-?[0-9]+$/.test(str)
    }
}

export default RhfCheckGroup
